import { useState } from 'react';

type Child = JSX.Element | string | null;

type Props = {
  children: Child[] | Child;
  collapsible?: boolean;
};

const Paragraph = ({ children, collapsible = false }: Props) => {
  const [collapsed, setCollapsed] = useState(collapsible);

  return (
    <div
      className={`inline gap-1 ${collapsible ? 'cursor-pointer' : ''}`}
      onClick={() => {
        if (collapsible) {
          setCollapsed(!collapsed);
        }
      }}
    >
      <p
        className={`flex-grow-1 text-left text-base leading-normal ${collapsed ? 'line-clamp-2' : ''}`}
      >
        {children}
        {!collapsed && collapsible && (
          <span className="underline font-semibold ml-1">Read less</span>
        )}
      </p>
    </div>
  );
};

export default Paragraph;
